import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild, Input, Output, EventEmitter, OnChanges, AfterViewInit } from '@angular/core';

import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatTable } from '@angular/material/table';
import { BackendTranslationService } from '@root/app/modules/cases/services';

@Component({
  selector: 'app-table-field',
  templateUrl: './table-field.component.html',
  styleUrls: ['./table-field.component.scss']
})
export class TableFieldComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() rows: any;
  @Input() form: any;
  @Input() dataValidation: any;
  @Input() tableKey: any;
  @Input() control: any;
  @Input() tableColumns: any;
  @Output() boundingBoxesDisplay: EventEmitter<any> = new EventEmitter();
  @Output() addRow: EventEmitter<any> = new EventEmitter();
  @Output() removeRow: EventEmitter<any> = new EventEmitter();
  @Output() rowOrderChanged: EventEmitter<any> = new EventEmitter();
  @ViewChild(MatTable, { static: true, read: ElementRef }) private matTableRef: ElementRef;
  @ViewChild('table', {static: true}) table: MatTable<any>;

  columns = [];
  displayedColumns: string[] = [];
  dataSource = [];
  tableSize: any;

  pressed = false;
  currentResizeIndex: number;
  startX: number;
  startWidth: number;
  isResizingRight: boolean;
  resizableMousemove: () => void;
  resizableMouseup: () => void;

  constructor(
    private renderer: Renderer2,
    private backendTranslationService: BackendTranslationService
  ) { }

  ngOnInit() {
    this.setColumns();
    this.setDisplayedColumns();
    if(this.control.colSizes.length > 0){
      this.control.colSizes.forEach((element, index) => {
        this.columns[index].width = element;
      });
    }
  }

  ngOnChanges(){
    this.setDataSource();
    if(this.columns){
      this.setTableResize(this.tableSize);
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if(this.columns){
        this.setTableResize(this.tableSize);
      }
      this.onResize(null);
    });
  }

  setColumns(){
    this.tableColumns.forEach((element) => {
      this.columns.push(
        {
          field: element.description,
          width: 10,
          key: element.name
        }
      );
    });
    this.columns.push({field: "add", width: 3, key: "add"});
  }

  setDataSource(){
    this.dataSource = [];
    if(this.rows){
      this.rows.forEach((row, index) => {
        this.dataSource.push({});
        row.forEach(element => {
          this.dataSource[index][element.key] = element;
        });
        this.dataSource[index]["remove"]="remove";
      })
    }
  }

  setTableResize(tableWidth: number) {
    if(tableWidth){
      let totWidth = 0;
      this.columns.forEach((column) => {
        totWidth += column.width;
      });
      const scale = (tableWidth) / totWidth;
      this.columns.forEach((column, index) => {
        column.width *= scale;
        this.control.colSizes[index] = column.width;
      });
    }
  }

  setDisplayedColumns() {
    this.columns.forEach((column, index) => {
      column.index = index;
      this.displayedColumns[index] = column.key;
    });
  }

  onResizeColumn(event: any, index: number) {
    this.checkResizing(event, index);
    this.currentResizeIndex = index;
    this.pressed = true;
    this.startX = event.pageX;
    this.startWidth = event.target.clientWidth;
    event.preventDefault();
    this.mouseMove(index);
  }

  private checkResizing(event, index) {
    const cellData = this.getCellData(index);
    if ((index === 0) || (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
      this.isResizingRight = true;
    } else {
      this.isResizingRight = false;
    }
  }

  private getCellData(index: number) {
    const headerRow = this.matTableRef.nativeElement.children[0];
    const cell = headerRow.children[index];
    return cell.getBoundingClientRect();
  }

  mouseMove(index: number) {
    this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
      if (this.pressed && event.buttons) {
        const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
        const width = this.startWidth + dx;
        if (this.currentResizeIndex === index && width > 50) {
          this.setColumnWidthChanges(index, width);
        }
      }
    });
    this.resizableMouseup = this.renderer.listen('document', 'mouseup', (event) => {
      if (this.pressed) {
        this.pressed = false;
        this.currentResizeIndex = -1;
        this.resizableMousemove();
        this.resizableMouseup();
      }
    });
  }

  setColumnWidthChanges(index: number, width: number) {
    const orgWidth = this.columns[index].width;
    const dx = width - orgWidth;
    if (dx !== 0) {
      const j = (this.isResizingRight) ? index + 1 : index - 1;
      const newWidth = this.columns[j].width - dx;
      if (newWidth > 50) {
        this.columns[index].width = width;
        this.control.colSizes[index] = width;
        this.columns[j].width = newWidth;
        this.control.colSizes[j] = newWidth;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
      this.tableSize = this.matTableRef.nativeElement.clientWidth
      if(this.columns && this.tableSize){
        this.setTableResize(this.tableSize);
      }
  }

  displayBoundingBox(event: any) {
    this.boundingBoxesDisplay.emit(event)
  }

  rowAdd(){
    this.addRow.emit();
  }

  rowRemove(index: number){
    this.removeRow.emit(index);
  }

  dropTable(event: CdkDragDrop<any[]>) {
    const prevIndex = this.dataSource.findIndex((d) => d === event.item.data);
    this.rowOrderChanged.emit({tableKey: this.tableKey, prevIndex: prevIndex, currentIndex: event.currentIndex});
  }

  preventDrag(event: any){
    event.stopPropagation();
  }

  trackByFn(index: any, item: any) {
    return index;
 }
}
